<div [ngClass]="{'all-content': !isScrolled, 'all-content-mini': isMenuOpen}" [class.scrolled]="isScrolled">

  <!-- Mobile Header -->
  <div class="mobile-header" *ngIf="mobile">
    <!-- Logo -->
    <div class="mobile-logo">
      <a (click)="acessaHome()">
        <img src="assets/CancianMenuLogoMob.png" alt="Logo Mobile">
      </a>
    </div>
    <!-- Navegação do Mobile -->
    <nav class="mobile-nav">
      <a (click)="acessaImoveis('2')" class="mobile-menu-link">Comprar</a>
      <a (click)="acessaImoveis('1')" class="mobile-menu-link">Alugar</a>
      <a (click)="acessaAnuncie()" class="mobile-menu-link" class="mobile-menu-link">Anunciar</a>

    </nav>
    <!-- Ícone do menu hambúrguer -->
    <div class="menu-icon" (click)="toggleMenu()">
      <i class="fa fa-bars" aria-hidden="true"></i>
    </div>
  </div>

  <!-- Mobile Side Menu -->
  <div class="menu-container" *ngIf="isMenuOpen && mobile">
    <div class="menu-content">
        <button type="button" class="btn-close" (click)="toggleMenu()">X</button>
        <div class="topic">
        <a routerLink="/" (click)="acessaHome()" class="title-menu">Home</a>
      </div>
      <div class="topic">
        <a (click)="acessaImoveis('1')" class="title-menu">Alugar</a>
      </div>
      <div class="topic">
        <a (click)="acessaImoveis('2')" class="title-menu">Comprar</a>
      </div>
        <div class="topic">
        <a (click)="acessarAreaCliente()" class="title-menu">Área do Cliente</a>
      </div>
      <div class="topic">
        <a (click)="acessaAnuncie()" class="title-menu">Anunciar</a>
      </div>
      <div class="topic">
        <a (click)="acessaContato()" class="title-menu">Contato</a>
      </div>
    
      <div class="topic">
        <a (click)="acessaTrabalhe()">Trabalhe conosco</a>
      </div>
      <div class="topic">
        <a (click)="acessaSobre()" class="title-menu">Sobre</a>
      </div>



    </div>
  </div>

  <!-- Desktop Navigation -->
  <div class="navigation-all menu" *ngIf="!mobile">
    <div class="navigation-all-item">
      <div class="margin-div">
        <a (click)="acessaHome()">
          <img class="img-menu" src="../../assets/CancianMenuLogo.png" alt="Logo Desktop" />
        </a>
      </div>
    </div>

    <div class="navigation-all-item navigation-links">
      <div class="topic">
        <a (click)="acessaImoveis('2')" class="title-menu">Comprar</a>
      </div>
      <div class="topic">
        <a (click)="acessaImoveis('1')" class="title-menu">Alugar</a>
      </div>
      <div class="topic">
        <a (click)=" acessaAnuncie()"  class="title-menu">Anunciar</a>
      </div>
    </div>

    <div class="navigation-all-item navigation-buttons">
      <nav class="nav-list">
        <div class="btn-group">
          <button type="button" class="btn btn-trabalhe-conosco" (click)="acessaTrabalhe()" [class.active]="selectedOpMenu === 1" (click)="selectedOpMenu = 1">Trabalhe Conosco</button>
          <button type="button" class="btn btn-contato"  (click)="acessaContato()"[class.active]="selectedOpMenu === 2" (click)="selectedOpMenu = 2">Contato</button>
          <button type="button" class="btn btn-sobre-nos" (click)="acessarAreaCliente()" [class.active]="selectedOpMenu === 3" (click)="selectedOpMenu = 3">Área do Cliente</button>
        </div>
      </nav>
    </div>
  </div>

</div>